import { useContext, useState } from 'react';
import TitleSection from './ArteFinalInfo/TitleSection';
import { UserContext } from '../../../context/UserProvider';
import CustomButton from '../../../ui/Button/CustomButton';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
// import { Tooltip } from 'react-tooltip';
import { useCreateFormatCustom } from '../../../hooks/useFormat';
import { FormatsSpecificationsByArte } from './FormatsSpecificationsByArte';
import FormProviderAsociate from '../Formatos/FormProviderAsociate';
import { useFormik } from 'formik';
import { IconButton, Modal } from '@mui/material';

import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import MaterialTooltip from '../../../ui/tooltip/MaterialTooltip';

const ArteFinalNotDescargable = ({ issue, isInformational }) => {
  const { idArte } = useParams();
  const { userRole } = useContext(UserContext);
  const { mutation } = useCreateFormatCustom(idArte);
  const navigate = useNavigate();
  const location = useLocation();
  const [openPopoverFormatCustom, setOpenPopoverFormatCustom] = useState(null);

  const handleClicFormatos = (e) => {
    const hasTrailingSlash = location.pathname.endsWith('/');

    if (!hasTrailingSlash) {
      navigate(`${location.pathname}/add-format`);
    } else {
      navigate(`${location.pathname}add-format`);
    }
  };

  // const handleOpenPopoverFormatCustom = (e) => {
  //   setOpenPopoverFormatCustom(e.currentTarget);
  // };

  const handleClosePopoverFormatCustom = () => {
    setOpenPopoverFormatCustom(null);
  };

  const handleConfirmFormatCustom = async (providerFormatValues) => {
    const body = {
      code: 'Personalizable',
      name: 'Personalizable',
      isCustom: true,
      arteFinal: idArte,
    };

    mutation.mutate({ bodyFormat: body, providerFormatValues });
    handleClosePopoverFormatCustom();
  };

  const formikProvider = useFormik({
    initialValues: {
      providers: [
        {
          code: '',
          provider: '',
          price: '',
          active: true,
          allowDuplicateCode: false,
        },
      ],
    },
    onSubmit: async (values) => {
      const providersLimpios = (values.providers || [])
        .filter((providerItem) => providerItem.provider)
        .map((providerItem) => ({
          code: providerItem.code?.trim() || '',
          provider: providerItem.provider || '',
          price: providerItem.price === '' ? null : Number(providerItem.price),
          active: providerItem.active ?? true,
          allowDuplicateCode: !!providerItem.allowDuplicateCode,
        }));

      if (!providersLimpios.length) {
        return;
      }

      handleConfirmFormatCustom(providersLimpios);
    },
  });

  return (
    <>
      <div className="imprimibles-section">
        <TitleSection
          title={
            <>
              Formatos
              {issue && (
                <MaterialTooltip variation="warning" title={issue}>
                  <IconButton className="alert-message">
                    <ReportProblemIcon color="warning" />
                  </IconButton>
                </MaterialTooltip>
              )}
            </>
          }
          classnames="display-sb-c w-100"
        >
          {userRole === 'MasterAdmin' && (
            <div style={{ display: 'flex', gap: '3rem', height: '30px' }}>
              <CustomButton onClick={(e) => handleClicFormatos(e)} classname="custom-button-formato">
                <AddCircleOutlineIcon />
                Formato
              </CustomButton>

              {/* {customFormat ? (
                <div>
                  <CustomButton classname="custom-button-formato button-tooltip-custom" disabled={true}>
                    <AddCircleOutlineIcon />
                    Formato Personalizado
                  </CustomButton>
                  <Tooltip anchorSelect=".button-tooltip-custom" place="top">
                    <span>No puedes añadir un formato personalizado porque ya hay uno</span>
                  </Tooltip>
                </div>
              ) : (
                <CustomButton classname="custom-button-formato" onClick={(e) => handleOpenPopoverFormatCustom(e)}>
                  <AddCircleOutlineIcon />
                  Formato Personalizado
                </CustomButton>
              )} */}
            </div>
          )}
        </TitleSection>
      </div>
      <FormatsSpecificationsByArte isInformational={isInformational} />
      <Modal open={openPopoverFormatCustom} onClose={handleClosePopoverFormatCustom}>
        <div className="modal-create-edit-format">
          <FormProviderAsociate goBack={handleClosePopoverFormatCustom} formik={formikProvider} custom={true} />
        </div>
      </Modal>
    </>
  );
};

export default ArteFinalNotDescargable;
